module.exports = __webpack_public_path__ + "img/2_accident-sp.79f1d153.jpg";